// 한글 자모 분해/조합 유틸
// 단어추리왕은 겹자음·겹모음을 모두 기본 자모로 펼쳐서 한 칸씩 사용한다.
// 예) 과자 → ㄱ ㅗ ㅏ ㅈ ㅏ (5칸), 꿈 → ㄱ ㄱ ㅜ ㅁ (4칸)

const HANGUL_BASE = 0xac00;
const HANGUL_END = 0xd7a3;

export const CHO = [
  'ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ',
  'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'
];

export const JUNG = [
  'ㅏ', 'ㅐ', 'ㅑ', 'ㅒ', 'ㅓ', 'ㅔ', 'ㅕ', 'ㅖ', 'ㅗ', 'ㅘ',
  'ㅙ', 'ㅚ', 'ㅛ', 'ㅜ', 'ㅝ', 'ㅞ', 'ㅟ', 'ㅠ', 'ㅡ', 'ㅢ', 'ㅣ'
];

export const JONG = [
  '', 'ㄱ', 'ㄲ', 'ㄳ', 'ㄴ', 'ㄵ', 'ㄶ', 'ㄷ', 'ㄹ', 'ㄺ',
  'ㄻ', 'ㄼ', 'ㄽ', 'ㄾ', 'ㄿ', 'ㅀ', 'ㅁ', 'ㅂ', 'ㅄ', 'ㅅ',
  'ㅆ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'
];

// 키보드에 존재하는 기본 자음 14개
export const BASE_CONSONANTS = [
  'ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'
];

// 키보드에 존재하는 기본 모음 10개
export const BASE_VOWELS = [
  'ㅏ', 'ㅑ', 'ㅓ', 'ㅕ', 'ㅗ', 'ㅛ', 'ㅜ', 'ㅠ', 'ㅡ', 'ㅣ'
];

// ㅐ/ㅔ/ㅒ/ㅖ 는 예시 키보드에 단독 키로 존재하므로 기본 자모로 취급한다.
export const EXTRA_VOWELS = ['ㅐ', 'ㅔ', 'ㅒ', 'ㅖ'];

// 게임에서 한 칸을 차지할 수 있는 모든 자모 (분해 결과에 등장 가능한 것들)
export const BASE_JAMO = [...BASE_CONSONANTS, ...BASE_VOWELS, ...EXTRA_VOWELS];

// 시드 인코딩용 고정 인덱스 테이블 — 순서를 절대 바꾸면 안 된다 (기존 시드가 깨짐)
export const JAMO_TABLE = [
  'ㄱ', 'ㄴ', 'ㄷ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅅ', 'ㅇ', 'ㅈ', 'ㅊ',
  'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ',
  'ㅏ', 'ㅐ', 'ㅑ', 'ㅒ', 'ㅓ', 'ㅔ', 'ㅕ', 'ㅖ', 'ㅗ', 'ㅛ',
  'ㅜ', 'ㅠ', 'ㅡ', 'ㅣ'
];

const JAMO_INDEX = JAMO_TABLE.reduce((acc, jamo, i) => {
  acc[jamo] = i;
  return acc;
}, {});

// 겹자모 → 기본 자모 배열
const SPLIT_MAP = {
  // 쌍자음
  'ㄲ': ['ㄱ', 'ㄱ'],
  'ㄸ': ['ㄷ', 'ㄷ'],
  'ㅃ': ['ㅂ', 'ㅂ'],
  'ㅆ': ['ㅅ', 'ㅅ'],
  'ㅉ': ['ㅈ', 'ㅈ'],
  // 겹받침
  'ㄳ': ['ㄱ', 'ㅅ'],
  'ㄵ': ['ㄴ', 'ㅈ'],
  'ㄶ': ['ㄴ', 'ㅎ'],
  'ㄺ': ['ㄹ', 'ㄱ'],
  'ㄻ': ['ㄹ', 'ㅁ'],
  'ㄼ': ['ㄹ', 'ㅂ'],
  'ㄽ': ['ㄹ', 'ㅅ'],
  'ㄾ': ['ㄹ', 'ㅌ'],
  'ㄿ': ['ㄹ', 'ㅍ'],
  'ㅀ': ['ㄹ', 'ㅎ'],
  'ㅄ': ['ㅂ', 'ㅅ'],
  // 겹모음
  'ㅘ': ['ㅗ', 'ㅏ'],
  'ㅙ': ['ㅗ', 'ㅐ'],
  'ㅚ': ['ㅗ', 'ㅣ'],
  'ㅝ': ['ㅜ', 'ㅓ'],
  'ㅞ': ['ㅜ', 'ㅔ'],
  'ㅟ': ['ㅜ', 'ㅣ'],
  'ㅢ': ['ㅡ', 'ㅣ']
};

// 기본 자모 두 개 → 겹자모 (조합용 역맵)
const MERGE_MAP = Object.entries(SPLIT_MAP).reduce((acc, [merged, [a, b]]) => {
  acc[`${a}${b}`] = merged;
  return acc;
}, {});

const CONSONANT_SET = new Set(BASE_CONSONANTS);
const VOWEL_SET = new Set([...BASE_VOWELS, ...EXTRA_VOWELS]);

export const isConsonant = (jamo) => CONSONANT_SET.has(jamo);
export const isVowel = (jamo) => VOWEL_SET.has(jamo);

const splitJamo = (jamo) => SPLIT_MAP[jamo] || [jamo];

/**
 * 한글 단어를 기본 자모 배열로 분해한다.
 * 한글 음절이 아닌 문자가 섞여 있으면 null을 반환한다.
 */
export const decomposeToJamo = (word) => {
  if (typeof word !== 'string' || word.length === 0) return null;

  const result = [];
  for (const char of word) {
    const code = char.charCodeAt(0);
    if (code < HANGUL_BASE || code > HANGUL_END) return null;

    const offset = code - HANGUL_BASE;
    const cho = CHO[Math.floor(offset / 588)];
    const jung = JUNG[Math.floor((offset % 588) / 28)];
    const jong = JONG[offset % 28];

    result.push(...splitJamo(cho));
    result.push(...splitJamo(jung));
    if (jong) result.push(...splitJamo(jong));
  }
  return result;
};

/** 분해했을 때의 자모 개수. 한글이 아니면 0. */
export const jamoLength = (word) => {
  const jamo = decomposeToJamo(word);
  return jamo ? jamo.length : 0;
};

const choIndex = (jamo) => CHO.indexOf(jamo);
const jungIndex = (jamo) => JUNG.indexOf(jamo);
const jongIndex = (jamo) => JONG.indexOf(jamo);

const mergeJamo = (a, b) => MERGE_MAP[`${a}${b}`] || null;

/**
 * 기본 자모 배열을 한글 문자열로 조합한다.
 * 두벌식 오토마타와 같은 그리디 규칙:
 *   초성 → (겹)중성 → (겹)종성, 단 다음 자모가 모음이면 종성을 넘긴다.
 * 조합할 수 없는 자모는 그대로 이어붙인다 (입력 중 미리보기용).
 */
export const composeFromJamo = (jamoList) => {
  if (!Array.isArray(jamoList) || jamoList.length === 0) return '';

  let out = '';
  let i = 0;

  while (i < jamoList.length) {
    const first = jamoList[i];

    // 초성 자리에 자음이 오지 않으면 조합 불가 → 그대로 출력
    if (!isConsonant(first) || choIndex(first) < 0) {
      out += first;
      i += 1;
      continue;
    }

    const next = jamoList[i + 1];
    let cho = first;
    let consumed = 1;

    // 쌍자음 초성: 자음-자음-모음 순서일 때만 (예: ㄱ ㄱ ㅜ ㅁ → 꿈)
    if (next && isConsonant(next) && isVowel(jamoList[i + 2])) {
      const merged = mergeJamo(first, next);
      if (merged && choIndex(merged) >= 0) {
        cho = merged;
        consumed = 2;
      }
    }

    let jung = jamoList[i + consumed];
    if (!jung || !isVowel(jung)) {
      // 초성 뒤에 모음이 없으면 음절이 성립하지 않는다 (입력 중 미리보기)
      out += first;
      i += 1;
      continue;
    }
    consumed += 1;

    // 겹모음 결합 시도
    const afterJung = jamoList[i + consumed];
    if (afterJung && isVowel(afterJung)) {
      const mergedVowel = mergeJamo(jung, afterJung);
      if (mergedVowel && jungIndex(mergedVowel) >= 0) {
        jung = mergedVowel;
        consumed += 1;
      }
    }

    // 종성 결합 시도
    let jong = '';
    const c1 = jamoList[i + consumed];
    if (c1 && isConsonant(c1) && jongIndex(c1) >= 0) {
      const c2 = jamoList[i + consumed + 1];
      const c3 = jamoList[i + consumed + 2];

      const paired = c2 && isConsonant(c2) ? mergeJamo(c1, c2) : null;

      if (paired && jongIndex(paired) >= 0 && !(c3 && isVowel(c3))) {
        // 겹받침: 그 다음이 모음이면 c2는 다음 글자의 초성이므로 겹받침이 아니다
        jong = paired;
        consumed += 2;
      } else if (!(c2 && isVowel(c2))) {
        // 단일 받침: 다음이 모음이면 그건 다음 글자의 초성이므로 받침으로 쓰지 않는다
        jong = c1;
        consumed += 1;
      }
    }

    const code =
      HANGUL_BASE +
      choIndex(cho) * 588 +
      jungIndex(jung) * 28 +
      (jong ? jongIndex(jong) : 0);

    out += String.fromCharCode(code);
    i += consumed;
  }

  return out;
};

/**
 * 자모 배열로 만들 수 있는 모든 한글 단어를 찾는다.
 *
 * 완전 분해는 본질적으로 중의적이다.
 *   ㅎ ㅏ ㄱ ㄱ ㅛ → 학교 / 하꾜
 *   ㅌ ㅗ ㄱ ㄱ ㅣ → 토끼 / 톡기
 * 그래서 그리디 규칙만으로는 원래 단어를 되돌릴 수 없다.
 * 가능한 모든 조합을 만들어 두고, 호출부에서 사전에 있는 것을 고른다.
 *
 * 후보 폭발을 막기 위해 개수를 제한한다.
 */
const MAX_CANDIDATES = 400;

export const composeCandidates = (jamoList) => {
  if (!Array.isArray(jamoList) || jamoList.length === 0) return [];

  const results = [];

  const walk = (index, acc) => {
    if (results.length >= MAX_CANDIDATES) return;
    if (index >= jamoList.length) {
      results.push(acc);
      return;
    }

    // 초성 후보: 단일 자음 또는 쌍자음
    const choOptions = [];
    const a = jamoList[index];
    if (isConsonant(a) && choIndex(a) >= 0) choOptions.push([a, 1]);

    const b = jamoList[index + 1];
    if (a && b && isConsonant(a) && isConsonant(b)) {
      const doubled = mergeJamo(a, b);
      if (doubled && choIndex(doubled) >= 0) choOptions.push([doubled, 2]);
    }

    for (const [cho, choLen] of choOptions) {
      // 중성 후보: 단일 모음 또는 겹모음
      const v1 = jamoList[index + choLen];
      if (!v1 || !isVowel(v1) || jungIndex(v1) < 0) continue;

      const jungOptions = [[v1, 1]];
      const v2 = jamoList[index + choLen + 1];
      if (v2 && isVowel(v2)) {
        const mergedVowel = mergeJamo(v1, v2);
        if (mergedVowel && jungIndex(mergedVowel) >= 0) {
          jungOptions.push([mergedVowel, 2]);
        }
      }

      for (const [jung, jungLen] of jungOptions) {
        const rest = index + choLen + jungLen;

        // 종성 후보: 없음 / 단일 / 겹받침
        const jongOptions = [['', 0]];
        const j1 = jamoList[rest];
        if (j1 && isConsonant(j1) && jongIndex(j1) >= 0) {
          jongOptions.push([j1, 1]);
          const j2 = jamoList[rest + 1];
          if (j2 && isConsonant(j2)) {
            const mergedJong = mergeJamo(j1, j2);
            if (mergedJong && jongIndex(mergedJong) >= 0) {
              jongOptions.push([mergedJong, 2]);
            }
          }
        }

        for (const [jong, jongLen] of jongOptions) {
          const code =
            HANGUL_BASE +
            choIndex(cho) * 588 +
            jungIndex(jung) * 28 +
            (jong ? jongIndex(jong) : 0);
          walk(rest + jongLen, acc + String.fromCharCode(code));
        }
      }
    }
  };

  walk(0, '');
  return results;
};

/**
 * 자모 배열을 한글 단어로 되돌린다.
 * 중의적인 경우 isValid(사전 조회 등)를 통과하는 후보를 우선한다.
 */
export const resolveWord = (jamoList, isValid) => {
  const candidates = composeCandidates(jamoList);
  if (candidates.length === 0) return composeFromJamo(jamoList);
  if (typeof isValid === 'function') {
    const match = candidates.find(isValid);
    if (match) return match;
  }
  return candidates[0];
};

/** 시드 인코딩용: 자모 → 0~27 인덱스. 없으면 -1 */
export const jamoToIndex = (jamo) =>
  JAMO_INDEX[jamo] === undefined ? -1 : JAMO_INDEX[jamo];

/** 시드 디코딩용: 인덱스 → 자모. 범위 밖이면 null */
export const indexToJamo = (index) =>
  index >= 0 && index < JAMO_TABLE.length ? JAMO_TABLE[index] : null;

export const CELL_STATE = {
  EMPTY: 'empty',
  FILLED: 'filled',
  CORRECT: 'correct',
  PRESENT: 'present',
  ABSENT: 'absent'
};

/**
 * Wordle 표준 2-pass 채점.
 * 중복 자모를 정답 개수만큼만 노란색으로 표시한다.
 */
export const evaluateGuess = (guess, answer) => {
  const result = new Array(guess.length).fill(CELL_STATE.ABSENT);
  const remaining = {};

  // 1차: 위치까지 일치
  for (let i = 0; i < guess.length; i++) {
    if (guess[i] === answer[i]) {
      result[i] = CELL_STATE.CORRECT;
    } else {
      remaining[answer[i]] = (remaining[answer[i]] || 0) + 1;
    }
  }

  // 2차: 남은 자모 중에 존재
  for (let i = 0; i < guess.length; i++) {
    if (result[i] === CELL_STATE.CORRECT) continue;
    if (remaining[guess[i]] > 0) {
      result[i] = CELL_STATE.PRESENT;
      remaining[guess[i]] -= 1;
    }
  }

  return result;
};

const STATE_RANK = {
  [CELL_STATE.ABSENT]: 1,
  [CELL_STATE.PRESENT]: 2,
  [CELL_STATE.CORRECT]: 3
};

/** 키보드 색상 누적: 더 높은 등급만 덮어쓴다 */
export const mergeKeyState = (prev, next) => {
  if (!prev) return next;
  return (STATE_RANK[next] || 0) > (STATE_RANK[prev] || 0) ? next : prev;
};
